import DescriptionPreview from "app/containers/Features/components/TicketDescriptionCommon/DescriptionPreview";
import { ITicketDescription } from "app/containers/Features/containers/Boards/containers/Tickets/types";
import { updateDescription } from "app/containers/Features/helper";
import descriptionIcon from "assets/svgs/ic_description.svg";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import CustomPopover from "./CustomPopover";

interface DescriptionProps {
  description: ITicketDescription;
}

const Description: React.FC<DescriptionProps> = ({ description }) => {
  const HOVER_CLOSE_DELAY = 120;
  const [open, setOpen] = useState(false);
  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearCloseTimeout = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  const handleHoverStart = () => {
    clearCloseTimeout();
    setOpen(true);
  };

  const handleHoverEnd = () => {
    clearCloseTimeout();
    closeTimeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, HOVER_CLOSE_DELAY);
  };

  useEffect(() => {
    return () => clearCloseTimeout();
  }, []);

  return (
    <CustomPopover
      show={open}
      onClose={(val) => setOpen(val)}
      trigger={
        <div
          className={clsx(
            "box-border flex size-4 shrink-0 items-center justify-center rounded border border-transparent hover:border-secondary",
            open && "border-secondary",
          )}
          onMouseEnter={handleHoverStart}
          onMouseLeave={handleHoverEnd}
          onClick={() => setOpen((prev) => !prev)}
        >
          <img src={descriptionIcon} alt="task-icon" className="size-4" />
        </div>
      }
      content={
        <div onMouseEnter={handleHoverStart} onMouseLeave={handleHoverEnd}>
          <DescriptionPreview
            hideResizeIcon={true}
            editorProps={{
              readonly: true,
              initialContent: updateDescription(description)?.rawContent,
              className: "p-6",
            }}
            className="border-secondary !px-0 !py-0 !h-[397px]"
          />
        </div>
      }
      className="!p-0 !overflow-auto !m-0 border-none w-[500px]"
    />
  );
};

export default Description;
